import { useEffect } from "react";
import {useHistory} from "react-router-dom";


export const ScrollTop = () => {
        const history = useHistory();
  
        useEffect(() => {
          // unlisten する為の関数が返される
          const unlisten = history.listen(() => {
            // history を監視して変更された際にスクロール量を0にする
            window.scrollTo(0, 0);
          });
          // unmount された際に history.listen を unlisten
          return () => unlisten(); 
        }, [history]);
        
        return null;
      }

